'use client';

import { useEffect } from 'react';

export function useBeforeUnload(shouldWarn: boolean) {
    useEffect(() => {
        const handler = (e: BeforeUnloadEvent) => {
            if (!shouldWarn) return;
            e.preventDefault();
            // @ts-ignore
            e.returnValue = '';
        };

        window.addEventListener('beforeunload', handler);
        return () => window.removeEventListener('beforeunload', handler);
    }, [shouldWarn]);
}


